/**
 * @fileoverview Chat page entry — composes hooks and presentational layout.
 * @module pages/Chat
 */
import useChat from "./chat/useChat.js";
import ChatView from "./chat/ChatView.jsx";

/** Composes Chat state/handlers and presentational layout. */
const Chat = () => {
  const viewModel = useChat();
  return <ChatView {...viewModel} />;
};

export default Chat;
